import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api/v1';

const dashboardService = {
  // Get dashboard statistics
  getDashboardStats: async () => {
    const response = await axios.get(`${API_BASE_URL}/dashboard/stats`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });
    return response.data;
  },

  // Get recent activities
  getRecentActivities: async (limit = 5) => {
    const response = await axios.get(`${API_BASE_URL}/dashboard/activities`, {
      params: { limit },
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });
    return response.data;
  }
};

export default dashboardService;